import {
  StoredDisclaimerProcedure,
  useAuth,
  useInitializeOfflineData
} from "duck";
import {
  GetOrganizationSettingsDocument,
  useRemoveDisclaimerProcedureSettingsMutation
} from "requests";

export const useDeleteDisclaimerProcedureSettings = (
  procedures: StoredDisclaimerProcedure[],
  onSuccess: () => void
) => {
  const [remove] = useRemoveDisclaimerProcedureSettingsMutation({
    ignoreResults: true
  });
  const [{ user }] = useAuth();
  const { loadDisclaimers } = useInitializeOfflineData();

  return () =>
    remove({
      variables: { input: { ids: procedures.map(proc => proc._id) } },
      refetchQueries: [GetOrganizationSettingsDocument]
    }).then(() => {
      onSuccess();
      loadDisclaimers(user.organization?._id || 0);
    });
};
